import { useState } from 'react';

export default function VideoGallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const images = [
    {
      id: 1,
      title: 'Implementação de Clínicas',
      description: 'Conheça o nosso processo completo de implementação chave-na-mão',
      image: 'https://public.readdy.ai/ai/img_res/92f6149105173a6e847fcd154e5481e1.jpg'
    },
    {
      id: 2,
      title: 'Projetos de Arquitetura',
      description: 'Veja exemplos dos nossos projetos de arquitetura para unidades de saúde',
      image: 'https://readdy.ai/api/search-image?query=Healthcare%20architecture%20blueprint%20and%203D%20visualization%2C%20modern%20medical%20facility%20design%20with%20clean%20lines%20and%20teal%20color%20scheme%2C%20professional%20architectural%20rendering%20showing%20clinic%20layout%2C%20contemporary%20healthcare%20space%20planning%20with%20natural%20light%2C%20innovative%20medical%20building%20design%20concept%20with%20detailed%20floor%20plans&width=800&height=600&seq=gallery-img-2&orientation=landscape'
    },
    {
      id: 3,
      title: 'Formação de Equipas',
      description: 'Descubra como preparamos as equipas para o sucesso',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20business%20training%20workshop%20with%20professional%20instructor%20teaching%20diverse%20group%20of%20healthcare%20professionals%20in%20bright%20modern%20conference%20room%2C%20participants%20actively%20engaged%20and%20taking%20notes%20at%20tables%2C%20presenter%20standing%20with%20whiteboard%20and%20digital%20screen%20showing%20educational%20content%20with%20teal%20branding%20elements%2C%20collaborative%20learning%20environment%20with%20natural%20daylight%20and%20contemporary%20office%20furniture%2C%20professional%20development%20seminar%20demonstrating%20knowledge%20transfer%20and%20team%20building%20in%20medical%20industry%20setting&width=800&height=600&seq=gallery-img-3-new-training&orientation=landscape'
    },
    {
      id: 4,
      title: 'Elaboração Plano Financeiro',
      description: 'Desenvolvemos planos financeiros completos para o seu projeto de saúde',
      image: 'https://readdy.ai/api/search-image?query=Professional%20financial%20planning%20workspace%20with%20detailed%20spreadsheets%20charts%20graphs%20on%20computer%20screens%2C%20modern%20office%20desk%20with%20financial%20documents%20calculator%20and%20teal%20accent%20colors%2C%20organized%20business%20analytics%20environment%20showing%20revenue%20projections%20and%20investment%20analysis%2C%20contemporary%20financial%20consulting%20setup%20with%20professional%20tools%20and%20clean%20minimalist%20background&width=800&height=600&seq=gallery-img-4-financial&orientation=landscape'
    },
    {
      id: 5,
      title: 'Legalização e Procedimentos',
      description: 'Entenda como simplificamos os processos legais',
      image: 'https://readdy.ai/api/search-image?query=Professional%20legal%20consultation%20for%20healthcare%20business%2C%20organized%20documents%20and%20digital%20tablets%20on%20modern%20desk%20with%20teal%20accents%2C%20clean%20office%20environment%20showing%20legal%20compliance%20process%2C%20contemporary%20workspace%20with%20healthcare%20regulations%20materials%2C%20professional%20business%20meeting%20setup%20with%20contracts%20and%20certificates&width=800&height=600&seq=gallery-img-5&orientation=landscape'
    },
    {
      id: 6,
      title: 'Marketing e Comunicação',
      description: 'Veja como criamos marcas de sucesso na área da saúde',
      image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20and%20tablet%20screens%20displaying%20vibrant%20social%20media%20platforms%20including%20Facebook%20Instagram%20LinkedIn%20Twitter%20with%20healthcare%20content%20posts%20and%20engagement%20metrics%2C%20professional%20digital%20marketing%20workspace%20with%20teal%20accent%20colors%2C%20contemporary%20social%20media%20management%20dashboard%20showing%20analytics%20and%20scheduled%20posts%2C%20clean%20minimalist%20background%20highlighting%20social%20network%20icons%20and%20interactive%20content%20for%20medical%20services%20branding&width=800&height=600&seq=gallery-img-6-socialmedia&orientation=landscape'
    }
  ];

  const openImage = (imageUrl: string) => {
    setSelectedImage(imageUrl);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  return (
    <section id="galeria" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Galeria</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Conheça o Nosso Trabalho
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore as nossas fotos e descubra como transformamos ideias em unidades de saúde de sucesso
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {images.map((item) => (
            <div 
              key={item.id}
              className="group cursor-pointer"
              onClick={() => openImage(item.image)}
            >
              <div className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="w-full h-64">
                  <img 
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center shadow-xl">
                    <i className="ri-search-line text-3xl text-white"></i>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white bg-gradient-to-t from-black/90 to-transparent">
                  <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                  <p className="text-sm text-white/90">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
            onClick={closeImage}
          >
            <div className="relative w-full max-w-6xl">
              <button
                onClick={closeImage}
                className="absolute -top-12 right-0 text-white hover:text-teal-400 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-4xl"></i>
              </button>
              <div className="relative bg-black rounded-2xl overflow-hidden">
                <img 
                  src={selectedImage}
                  alt="Imagem ampliada"
                  className="w-full h-auto max-h-[85vh] object-contain"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}